
import React from 'react';

export const PaypalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7 11l3-8h4c1.1 0 2 .9 2 2 0 .34-.09.66-.23.94A3 3 0 0 1 14 10a2.47 2.47 0 0 1-1 .26H9.5" />
    <path d="M14 11.5V14a2 2 0 0 1-2 2H9l-4.5 4.5L6 16 3 11" />
    <path d="M4.5 8.5h4l.5-1.5" />
  </svg>
);

export const HubspotIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 3v18h18" />
    <circle cx="8" cy="10" r="3" />
    <path d="M8 16v1" />
    <circle cx="16" cy="16" r="3" />
    <path d="M16 10v-1" />
  </svg>
);

export const ZohoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    <circle cx="12" cy="12" r="4" />
  </svg>
);
